import { styled } from '@mui/material/styles'
import InputAdornment from '@mui/material/InputAdornment'
import { UInput } from './UInput.component'

const LockIcon = () => (
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" data-testid="country-box-svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5714 7.54812C15.9863 7.9816 17 9.15135 17 10.5263V16.8421C17 18.5862 15.369 20 13.3571 20H3.64286C1.63096 20 0 18.5862 0 16.8421V10.5263C0 9.15135 1.0137 7.9816 2.42857 7.54812V5.26316C2.42857 2.35641 5.14685 0 8.5 0C11.8531 0 14.5714 2.35641 14.5714 5.26316V7.54812ZM4.85714 7.36842H12.1429V5.26316C12.1429 3.51909 10.5119 2.10526 8.5 2.10526C6.4881 2.10526 4.85714 3.51909 4.85714 5.26316V7.36842ZM8.5 10.5263C7.15872 10.5263 6.07143 11.4689 6.07143 12.6316C6.07143 13.4108 6.5598 14.0912 7.28571 14.4552V16.8421H9.71429V14.4552C10.4402 14.0912 10.9286 13.4108 10.9286 12.6316C10.9286 11.4689 9.84128 10.5263 8.5 10.5263Z"
            fill="#D9D9D9"
            data-testid="country-box-path"
        />
    </svg>
)

const FlagImg = styled('img')`
    width: 24px;
    height: 18px;
    object-fit: cover;
    border-radius: 2px;
    flex-shrink: 0;
`

export interface CountryBoxProps {
    value: string
    label?: string
    flagUrl?: string
    inputTestId?: string
}

export const CountryBox = ({ value, label, flagUrl, inputTestId }: CountryBoxProps) => (
    <UInput
        value={value}
        label={label}
        disabled
        fullWidth
        slotProps={{
            htmlInput: {
                ...(inputTestId ? { 'data-testid': inputTestId } : {})
            },
            input: {
                autoComplete: 'new-password',
                startAdornment: flagUrl ? (
                    <InputAdornment position="start" data-testid="country-box-input-adornment-1">
                        <FlagImg src={flagUrl} alt="" data-testid="country-box-flag-img" />
                    </InputAdornment>
                ) : undefined,
                endAdornment: (
                    <InputAdornment position="end" sx={{ width: 17, height: 20 }} data-testid="country-box-input-adornment-2">
                        <LockIcon data-testid="country-box-lock-icon" />
                    </InputAdornment>
                )
            }
        }}
        sx={{
            '& .MuiInputBase-root, & .MuiInputBase-root.Mui-disabled': {
                backgroundColor: '#f8fafc !important'
            },
            '& .MuiInputBase-input.Mui-disabled': {
                color: 'rgba(21, 56, 98, 0.4)',
                WebkitTextFillColor: 'rgba(21, 56, 98, 0.4)'
            }
        }}
        data-testid="country-box-uinput"
    />
)
